import { render, staticRenderFns } from "./MiniProductsTable.vue?vue&type=template&id=5d5c22cf&scoped=true&"
import script from "./MiniProductsTable.vue?vue&type=script&lang=js&"
export * from "./MiniProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniProductsTable.vue?vue&type=style&index=0&id=5d5c22cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c22cf",
  null
  
)

export default component.exports